import { render, staticRenderFns } from "./examRankComparisonTableDialog.vue?vue&type=template&id=a0bff11a&scoped=true"
import script from "./examRankComparisonTableDialog.vue?vue&type=script&lang=js"
export * from "./examRankComparisonTableDialog.vue?vue&type=script&lang=js"
import style0 from "./examRankComparisonTableDialog.vue?vue&type=style&index=0&id=a0bff11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bff11a",
  null
  
)

export default component.exports